/**
 *
 * FileUploader
 *
 */

import React from 'react';
import { Upload } from 'antd';

import './style.css';

const FileUploader = ({ uploadButton, acceptFileTypes, ...rest }: any) => {
  let acceptType = acceptFileTypes;
  if (typeof acceptFileTypes === 'object') {
    acceptType = acceptFileTypes.join(',');
  }
  return (
    <Upload {...rest} accept={acceptType}>
      {uploadButton}
    </Upload>
  );
};

export default FileUploader;
